import angular from 'angular';
import adviserSelect from './adviserSelect';

export default angular
  .module('components.adviserSelect', [])
  .component('adviserSelect', adviserSelect).name;
